import React, { forwardRef, useEffect } from "react";
import { Multiselect } from "multiselect-react-dropdown";

class CustomMultiSelect extends Multiselect {
    constructor(props) {
        super(props);
        this.onArrowKeyNavigation = this.onArrowKeyNavigation.bind(this);
    }
    onArrowKeyNavigation() {}
}

function MultiSelect(props, ref) {
    const { options, onChange, placeholder, singleSelect, showCheckbox, ...restProps } = props;

    //Close menu on pressing Esc key
    useEffect(() => {
        const listener = event => {
            if (event.key === "Escape") {
                if (document.activeElement) {
                    document.activeElement.blur();
                }
            }
        };
        document.addEventListener("keydown", listener);
        return () => document.removeEventListener("keydown", listener);
        //eslint-disable-next-line
    }, []);

    return (
        <div className="trpr-fs-multiselect">
            <CustomMultiSelect
                ref={ref}
                onSelect={onChange}
                onRemove={onChange}
                placeholder={placeholder}
                options={options}
                displayValue="name"
                showCheckbox={showCheckbox}
                closeIcon="cancel"
                closeOnSelect={false}
                singleSelect={singleSelect}
                {...restProps}
            />
        </div>
    );
}

const _MultiSelect = forwardRef(MultiSelect);
_MultiSelect.displayName = "MultiSelect";
_MultiSelect.defaultProps = {
    singleSelect: false,
    showCheckbox: true,
};

export default _MultiSelect;
